<!--  -->
<template>
    <div>
        <div class="invoice-header flex align-center justify-around" :class="isFixed ? 'fixed' : ''">
            <slot name="left"></slot>
            <div class="invoice-date flex align-center" @click="showDatePickFun('beginTime')">
                {{ beginTime || '选择开始时间'}}
            </div>
            <div>至</div>
            <div class="invoice-date flex align-center" @click="showDatePickFun('endTime')">
                {{ endTime || '选择结束时间' }}
            </div>
            <slot name="right"></slot>
        </div>

        <!-- 选择时间 -->
        <van-action-sheet v-model="showDatePick">
            <div class="content">
                <van-datetime-picker v-model="currentDate" @cancel="showDatePick = false" @confirm="getPickDate"
                    v-bind="$attrs" v-on="$listeners" />
            </div>
        </van-action-sheet>
    </div>
</template>

<script>

import dayjs from 'dayjs'
export default {
    name: "DateRangePicker",
    props: {
        //开始时间
        beginTime: {
            type: String,
            default: "",
        },
        //结束时间
        endTime: {
            type: String,
            default: "",
        },


        //是否固定位置
        isFixed: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            timeField: 'beginTime',
            showDatePick: false,
            currentDate: new Date(),
        };
    },

    mounted() {
        console.log(this.$attrs);
    },

    methods: {

        showDatePickFun(timeField) {
            this.timeField = timeField
            this.showDatePick = true;
        },
        // 时间选择
        getPickDate(value) {
            let timeStr = dayjs(value).format('YYYY-MM-DD HH:mm:ss')

            if (this.timeField == 'beginTime' && this.endTime) {
                if (dayjs(timeStr).toJSON() > dayjs(this.endTime).toJSON()) {
                    this.$toast('结束时间要大于开始时间')
                    return
                }
            }
            else if (this.timeField == 'endTime' && this.beginTime) {
                if (dayjs(timeStr).toJSON() < dayjs(this.beginTime).toJSON()) {
                    this.$toast('结束时间要大于开始时间')
                    return
                }
            }
            this.$emit(`update:${this.timeField}`, timeStr)
            this.showDatePick = false;
        },



    },
};
</script>
<style lang="less" scoped>
@import "~@/assets/style/color.less";

.fixed {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
}

.invoice-header {
    width: 750px;
    height: 90px;
    padding: 30px 10px;

    background-color: #fff;

    .invoice-date {
        width: 300px;
        background-color: #F5F5F5;
        height: 50px;
        line-height: 50px;
        border-radius: 10px;
        text-align: center;
        padding: 10px 20px;
        font-size: 26px;
        color: #666666;

        i {
            margin: 0 4px;
        }
    }

    .invoice-header-cancle {
        margin-left: 30px;

        img {
            width: 32px;
            height: 32px;
            margin-right: 15px;
        }
    }

    .invoice-header-batch {
        margin-left: 30px;
        color: @main-color;

        img {
            width: 32px;
            height: 32px;
            margin-right: 15px;
        }
    }
}
</style>
